var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 39,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#badge_svg__filter0_d_21011_131738)",
    clipPath: "url(#badge_svg__clip0_21011_131738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.422 36.741c-.734 0-1.512-.209-2.266-.412-.749-.201-1.524-.41-2.246-.41s-1.497.209-2.246.41c-.752.203-1.532.412-2.266.412-.354 0-.67-.047-.967-.144-1.061-.344-1.807-1.276-2.529-2.176-.492-.612-.955-1.19-1.504-1.592-.56-.407-1.293-.686-2.002-.956-1.072-.408-2.18-.83-2.826-1.719-.64-.877-.7-2.056-.759-3.197-.039-.764-.08-1.552-.296-2.22-.205-.631-.606-1.242-1.031-1.89-.638-.97-1.298-1.974-1.298-3.114s.66-2.142 1.298-3.114c.425-.646.826-1.257 1.031-1.888.218-.669.258-1.457.296-2.22.06-1.14.12-2.318.759-3.197.647-.89 1.754-1.31 2.826-1.72.71-.27 1.442-.549 2.002-.955.549-.4 1.012-.979 1.504-1.591.722-.901 1.468-1.832 2.53-2.176.298-.096.614-.144.968-.144.734 0 1.512.209 2.265.412.749.201 1.525.41 2.246.41.722 0 1.497-.209 2.246-.41.754-.203 1.532-.412 2.266-.412.354 0 .67.047.966.144 1.061.344 1.808 1.276 2.53 2.176.492.612.955 1.191 1.505 1.59.56.407 1.292.686 2.001.957 1.072.408 2.18.83 2.826 1.719.64.877.7 2.056.759 3.197.04.763.08 1.551.296 2.22.205.63.606 1.242 1.032 1.888.637.972 1.298 1.975 1.298 3.114 0 1.14-.66 2.143-1.299 3.114-.425.647-.826 1.258-1.03 1.89-.218.667-.258 1.456-.297 2.22-.06 1.14-.12 2.318-.759 3.197-.646.89-1.754 1.31-2.826 1.719-.71.27-1.442.55-2.001.956-.55.4-1.013.979-1.505 1.591-.722.901-1.468 1.832-2.53 2.176a3.107 3.107 0 01-.967.144v.001z",
    fill: "url(#badge_svg__paint0_linear_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.429 19.736c0 1.807-1.79 3.31-2.32 4.94-.548 1.69-.002 3.953-1.026 5.36-1.034 1.42-3.362 1.595-4.784 2.629-1.406 1.024-2.286 3.19-3.976 3.738-1.63.53-3.608-.688-5.416-.688-1.807 0-3.785 1.217-5.415.688-1.69-.548-2.57-2.714-3.977-3.738-1.42-1.034-3.75-1.209-4.783-2.63-1.024-1.406-.477-3.67-1.027-5.36-.53-1.63-2.32-3.132-2.32-4.94 0-1.806 1.79-3.308 2.32-4.939.548-1.69.002-3.953 1.026-5.36 1.034-1.42 3.362-1.595 4.783-2.629 1.406-1.024 2.287-3.19 3.977-3.738 1.63-.53 3.608.688 5.415.688s3.785-1.217 5.415-.688c1.69.548 2.57 2.714 3.977 3.738 1.421 1.034 3.75 1.208 4.784 2.63 1.023 1.406.477 3.669 1.026 5.36.53 1.63 2.32 3.132 2.32 4.939z",
    fill: "url(#badge_svg__paint1_linear_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.421 35.716c-.598 0-1.278-.183-1.999-.376-.813-.22-1.654-.445-2.512-.445-.858 0-1.7.226-2.513.445-.72.194-1.4.376-1.999.376-.245 0-.457-.03-.65-.093-.77-.25-1.39-1.023-2.047-1.843-.511-.638-1.041-1.299-1.702-1.78-.67-.486-1.467-.79-2.24-1.085-.974-.37-1.895-.721-2.362-1.363-.46-.632-.51-1.61-.564-2.647-.043-.83-.088-1.686-.346-2.483-.247-.762-.707-1.46-1.15-2.135-.58-.884-1.129-1.718-1.129-2.551 0-.834.548-1.667 1.13-2.551.444-.675.902-1.373 1.15-2.135.257-.797.302-1.655.345-2.484.052-1.036.103-2.014.563-2.646.467-.642 1.388-.992 2.362-1.364.772-.293 1.57-.597 2.24-1.085.66-.48 1.189-1.14 1.702-1.779.656-.819 1.276-1.592 2.046-1.843.194-.062.406-.093.65-.093.6 0 1.28.183 2 .376.813.219 1.654.445 2.512.445.858 0 1.7-.226 2.512-.445.72-.194 1.401-.376 1.999-.376.244 0 .457.03.65.093.77.25 1.39 1.024 2.047 1.843.511.638 1.041 1.298 1.701 1.779.67.488 1.468.792 2.24 1.085.975.372 1.895.722 2.363 1.364.46.632.51 1.61.564 2.646.043.83.087 1.687.346 2.484.247.762.706 1.46 1.15 2.135.58.884 1.129 1.719 1.129 2.55 0 .833-.549 1.668-1.13 2.552-.444.675-.902 1.373-1.15 2.135-.258.797-.302 1.655-.345 2.483-.053 1.037-.103 2.015-.564 2.647-.467.642-1.388.992-2.363 1.363-.772.294-1.57.598-2.24 1.086-.66.48-1.19 1.14-1.701 1.779-.657.818-1.276 1.592-2.047 1.843a2.08 2.08 0 01-.65.093h.002z",
    fill: "url(#badge_svg__paint2_linear_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.421 35.716c-.598 0-1.278-.183-1.999-.376-.813-.22-1.654-.445-2.512-.445-.858 0-1.7.226-2.513.445-.72.194-1.4.376-1.999.376-.245 0-.457-.03-.65-.093-.77-.25-1.39-1.023-2.047-1.843-.511-.638-1.041-1.299-1.702-1.78-.67-.486-1.467-.79-2.24-1.085-.974-.37-1.895-.721-2.362-1.363-.46-.632-.51-1.61-.564-2.647-.043-.83-.088-1.686-.346-2.483-.247-.762-.707-1.46-1.15-2.135-.58-.884-1.129-1.718-1.129-2.551 0-.834.548-1.667 1.13-2.551.444-.675.902-1.373 1.15-2.135.257-.797.302-1.655.345-2.484.052-1.036.103-2.014.563-2.646.467-.642 1.388-.992 2.362-1.364.772-.293 1.57-.597 2.24-1.085.66-.48 1.189-1.14 1.702-1.779.656-.819 1.276-1.592 2.046-1.843.194-.062.406-.093.65-.093.6 0 1.28.183 2 .376.813.219 1.654.445 2.512.445.858 0 1.7-.226 2.512-.445.72-.194 1.401-.376 1.999-.376.244 0 .457.03.65.093.77.25 1.39 1.024 2.047 1.843.511.638 1.041 1.298 1.701 1.779.67.488 1.468.792 2.24 1.085.975.372 1.895.722 2.363 1.364.46.632.51 1.61.564 2.646.043.83.087 1.687.346 2.484.247.762.706 1.46 1.15 2.135.58.884 1.129 1.719 1.129 2.55 0 .833-.549 1.668-1.13 2.552-.444.675-.902 1.373-1.15 2.135-.258.797-.302 1.655-.345 2.483-.053 1.037-.103 2.015-.564 2.647-.467.642-1.388.992-2.363 1.363-.772.294-1.57.598-2.24 1.086-.66.48-1.19 1.14-1.701 1.779-.657.818-1.276 1.592-2.047 1.843a2.08 2.08 0 01-.65.093h.002z",
    fill: "url(#badge_svg__paint3_linear_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.421 34.896c-.489 0-1.118-.169-1.785-.348-.866-.234-1.761-.473-2.726-.473-.965 0-1.86.24-2.726.473-.666.18-1.295.348-1.786.35a1.29 1.29 0 01-.397-.054c-.537-.174-1.083-.854-1.66-1.576-.545-.68-1.108-1.384-1.858-1.929-.759-.552-1.61-.875-2.43-1.188-.858-.326-1.668-.635-1.992-1.08-.317-.435-.362-1.295-.408-2.206-.046-.883-.093-1.795-.385-2.695-.282-.867-.77-1.612-1.244-2.332-.512-.778-.995-1.513-.995-2.101 0-.588.483-1.323.995-2.1.473-.721.962-1.466 1.244-2.333.292-.9.34-1.812.385-2.693.046-.913.09-1.773.408-2.207.324-.445 1.133-.754 1.991-1.08.823-.314 1.673-.637 2.43-1.19.75-.544 1.314-1.247 1.858-1.928.578-.722 1.124-1.402 1.661-1.576.11-.036.241-.053.397-.053.49 0 1.12.17 1.786.35.866.231 1.76.472 2.726.472s1.86-.24 2.724-.473c.668-.18 1.297-.35 1.787-.35.158 0 .287.018.397.054.538.174 1.082.854 1.66 1.576.546.68 1.11 1.384 1.859 1.929.758.552 1.608.875 2.43 1.188.858.327 1.668.636 1.992 1.08.317.436.361 1.297.408 2.208.045.882.092 1.794.385 2.694.281.867.77 1.612 1.244 2.332.511.779.994 1.514.994 2.101 0 .588-.483 1.323-.994 2.1-.474.72-.964 1.465-1.246 2.333-.292.9-.339 1.812-.384 2.695-.047.91-.091 1.771-.409 2.207-.324.444-1.133.753-1.991 1.079-.822.313-1.672.637-2.43 1.189-.75.544-1.313 1.249-1.86 1.928-.577.72-1.123 1.402-1.659 1.576-.11.036-.24.053-.397.053l.001-.002z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.479 13.024s-.632-.89-1.23-.952c-.537-.056-1.066.126-1.066.126s1.126.805 1.663.962c.417.123.632-.136.632-.136h.001z",
    fill: "url(#badge_svg__paint4_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.243 23.223s.28.19.636-.132c.46-.417 1.052-2.084 1.052-2.084s-.509.297-.935.698c-.477.448-.753 1.518-.753 1.518z",
    fill: "url(#badge_svg__paint5_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.59 25.013a11.679 11.679 0 001.057-4.382c.05.014.327.08.593-.282.376-.514.66-2.279.66-2.279s-.447.41-.794.901c-.308.435-.42 1.218-.455 1.527a12.514 12.514 0 00-.154-2.563c.105-.019.315-.098.451-.443.241-.607.09-2.39.09-2.39s-.332.527-.548 1.103c-.112.298-.132.689-.122 1.025a13.002 13.002 0 00-.555-1.887c.084-.027.314-.136.396-.544.132-.65-.337-2.363-.337-2.363s-.23.589-.34 1.202c-.075.413.032.95.128 1.312a12.626 12.626 0 00-1.062-2.012c.06-.031.298-.18.305-.63.008-.665-.79-2.238-.79-2.238s-.113.627-.103 1.252c.007.523.325 1.172.483 1.464a12.566 12.566 0 00-.866-1.14c-.075-.239-.313-.8-.982-1.235-.779-.506-2.066-1.003-2.066-1.003s1.38 1.318 2.094 1.857c.424.32.774.44.914.479a12.251 12.251 0 011.998 3.268c-.185-.308-.477-.709-.813-.823-.506-.172-1.05-.11-1.05-.11s.932 1.033 1.425 1.305c.293.161.51.08.598.032.285.762.5 1.556.638 2.372-.099-.32-.343-.991-.732-1.225-.463-.28-1.003-.338-1.003-.338s.724 1.217 1.16 1.593c.286.247.534.18.603.155a13.374 13.374 0 01.145 2.652c-.011-.142-.107-1.139-.53-1.53-.407-.377-.926-.553-.926-.553s.503 1.354.868 1.818c.27.343.56.288.587.283-.043.87-.177 1.712-.395 2.521.016-.226.06-1.136-.27-1.583-.337-.46-.817-.747-.817-.747s.27 1.44.551 1.976c.2.38.475.405.523.406a11.176 11.176 0 01-.855 2.192c.072-.344.172-1.023-.033-1.447a3.414 3.414 0 00-.677-.913s.023 1.472.207 2.061c.106.337.302.457.396.497a11.383 11.383 0 01-1.56 2.195c.127-.296.386-.993.251-1.485a3.625 3.625 0 00-.506-1.046s-.235 1.45-.162 2.068c.045.363.223.522.308.579-.08.086-.16.173-.243.258-.416.42-.87.814-1.354 1.181.218-.292.509-.764.505-1.183-.006-.598-.223-1.158-.223-1.158s-.602 1.321-.693 1.936c-.049.327.055.525.125.62-.53.38-1.098.727-1.693 1.038.233-.17.858-.672.965-1.2.117-.584.01-1.181.01-1.181s-.874 1.154-1.1 1.732c-.154.397-.007.648.029.7a15.69 15.69 0 01-1.886.816c.311-.157.966-.534 1.15-1.003.217-.558.201-1.164.201-1.164s-1.096 1.005-1.433 1.54c-.227.359-.124.624-.094.69a16.94 16.94 0 01-2.366.63 6.99 6.99 0 00-1.506.455 6.99 6.99 0 00-1.506-.455 16.648 16.648 0 01-2.366-.63c.032-.066.132-.331-.094-.69-.337-.535-1.433-1.54-1.433-1.54s-.016.606.201 1.164c.184.47.839.847 1.15 1.003a15.681 15.681 0 01-1.886-.816c.036-.053.183-.303.028-.7-.225-.578-1.1-1.732-1.1-1.732s-.106.597.011 1.181c.106.529.732 1.03.965 1.2a14.24 14.24 0 01-1.693-1.037c.07-.095.172-.294.124-.621-.09-.615-.692-1.936-.692-1.936s-.219.561-.223 1.158c-.004.419.287.89.505 1.184-.485-.368-.94-.761-1.354-1.182-.083-.085-.162-.172-.243-.258.085-.057.263-.218.307-.58.074-.616-.16-2.067-.16-2.067s-.35.475-.507 1.046c-.135.492.124 1.19.25 1.485a11.332 11.332 0 01-1.56-2.195c.096-.04.292-.16.396-.497.185-.589.208-2.061.208-2.061s-.423.388-.677.913c-.206.424-.105 1.103-.033 1.447a11.106 11.106 0 01-.855-2.192c.047-.001.324-.026.521-.406.28-.536.551-1.976.551-1.976s-.48.287-.817.747c-.329.448-.287 1.356-.27 1.583a11.964 11.964 0 01-.394-2.521c.027.006.317.061.586-.283.364-.464.868-1.818.868-1.818s-.519.176-.926.553c-.421.391-.517 1.388-.53 1.53a13.391 13.391 0 01.145-2.652c.07.026.318.092.604-.155.435-.376 1.16-1.593 1.16-1.593s-.54.059-1.004.338c-.388.235-.633.906-.731 1.226.138-.816.353-1.61.638-2.373.087.048.305.129.597-.032.493-.273 1.425-1.306 1.425-1.306s-.543-.061-1.05.111c-.335.114-.628.514-.812.822a12.292 12.292 0 011.997-3.267c.142-.04.49-.16.915-.48.714-.54 2.094-1.856 2.094-1.856s-1.286.497-2.067 1.003c-.667.434-.906.996-.98 1.235-.313.362-.602.743-.868 1.14.159-.293.476-.942.484-1.464.01-.624-.102-1.252-.102-1.252s-.8 1.573-.791 2.238c.006.45.245.599.305.63-.414.635-.77 1.309-1.062 2.012.096-.361.203-.899.128-1.312a7.401 7.401 0 00-.34-1.202s-.47 1.715-.338 2.363c.083.408.313.517.396.544-.231.611-.417 1.24-.554 1.887.01-.336-.01-.727-.122-1.025a7.05 7.05 0 00-.548-1.103s-.151 1.783.09 2.39c.136.345.346.424.45.443a13.46 13.46 0 00-.164 2.084c0 .16.005.32.01.479-.033-.309-.147-1.092-.454-1.527a6.47 6.47 0 00-.794-.901s.284 1.765.66 2.28c.264.36.542.295.593.28a11.655 11.655 0 001.057 4.383c-.18-.27-.413-.562-.665-.713-.49-.295-1.038-.468-1.038-.468s.878 1.5 1.403 1.8c.327.189.544.064.618.007.352.65.77 1.265 1.25 1.845-.242-.216-.548-.445-.835-.522-.541-.146-1.11-.159-1.11-.159s1.2 1.205 1.78 1.348c.367.09.545-.1.6-.174.083.09.165.18.251.268.316.32.654.623 1.01.912-.26-.152-.57-.294-.844-.314-.559-.042-1.124.054-1.124.054s1.374.962 1.977.99c.38.019.528-.199.572-.283.507.367 1.048.704 1.616 1.009-.327-.153-.892-.378-1.32-.338-.575.053-1.13.242-1.13.242s1.54.717 2.163.643c.457-.055.543-.373.55-.408.554.284 1.133.537 1.733.76-.374-.099-.972-.218-1.394-.117a6.012 6.012 0 00-1.131.412s1.716.472 2.36.302c.43-.113.498-.395.51-.473a16.86 16.86 0 002.357.627c.55.104 1.014.248 1.406.413-.58.269-.99.58-1.273.858l.1.032a4.506 4.506 0 011.288-.84c.585.26 1 .566 1.288.84l.1-.032a4.486 4.486 0 00-1.274-.858 6.995 6.995 0 011.406-.413c.81-.154 1.6-.365 2.358-.627.011.078.081.36.51.473.643.17 2.36-.303 2.36-.303s-.544-.271-1.131-.411c-.422-.101-1.02.018-1.395.117a15.64 15.64 0 001.732-.76c.01.034.094.353.551.408.624.075 2.164-.643 2.164-.643s-.556-.19-1.13-.242c-.429-.04-.994.184-1.32.338a14.511 14.511 0 001.615-1.01c.044.085.193.302.572.285.603-.03 1.978-.991 1.978-.991s-.566-.096-1.125-.054c-.273.02-.583.162-.845.314.357-.288.695-.592 1.01-.912.087-.087.17-.178.253-.268.054.074.232.263.6.174.58-.143 1.78-1.348 1.78-1.348s-.57.012-1.11.159c-.288.077-.594.306-.836.522.48-.579.899-1.196 1.25-1.845.073.057.291.182.619-.006.524-.303 1.402-1.801 1.402-1.801s-.55.173-1.037.468c-.252.151-.486.443-.665.713z",
    fill: "url(#badge_svg__paint6_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57 12.071c-.6.063-1.231.952-1.231.952s.215.258.632.136c.537-.157 1.663-.963 1.663-.963s-.529-.182-1.066-.125h.001z",
    fill: "url(#badge_svg__paint7_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.575 23.223s-.276-1.07-.753-1.518c-.428-.4-.935-.698-.935-.698s.592 1.667 1.052 2.084c.357.323.636.132.636.132z",
    fill: "url(#badge_svg__paint8_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.897 8.278l.822-.516.82.516-.237-.94.744-.622-.967-.065-.36-.9-.362.9-.967.065.743.622-.236.94z",
    fill: "url(#badge_svg__paint9_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.153 8.763l.1.498.271-.43.505.06-.323-.391.212-.461-.473.185-.372-.344.03.508-.442.248.492.127z",
    fill: "url(#badge_svg__paint10_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.284 8.473l.473-.528.68.197-.354-.614.398-.586-.694.149-.435-.56-.073.705-.667.24.648.287.023.71z",
    fill: "url(#badge_svg__paint11_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.878 8.832l.273.429.1-.498.491-.127-.444-.248.032-.508-.373.345-.472-.186.212.46-.323.393.504-.06z",
    fill: "url(#badge_svg__paint12_radial_21011_131738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.966 8.142l.68-.197.474.528.022-.71.65-.286-.668-.241-.073-.706-.435.56-.693-.148.398.586-.355.614z",
    fill: "url(#badge_svg__paint13_radial_21011_131738)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint4_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.42946 0 0 1.38704 29.113 13.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint5_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.78568 0 0 2.78437 32.927 23.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint6_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.262 34.97) scale(29.6022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint7_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.42816 0 0 1.38647 10.27 13.257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint8_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.262 34.97) scale(29.6022)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint9_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.261 34.97) scale(29.6022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint10_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.2463 0 0 16.1689 13.08 23.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint11_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.8215 0 0 22.7488 14.819 28.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint12_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.2463 0 0 16.1689 23.793 23.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "badge_svg__paint13_radial_21011_131738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(20.8215 0 0 22.7488 21.13 28.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E1E1E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "badge_svg__paint0_linear_21011_131738",
    x1: 24.932,
    y1: 3.348,
    x2: 12.251,
    y2: 44.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "badge_svg__paint1_linear_21011_131738",
    x1: 6.144,
    y1: 5.08,
    x2: 33.608,
    y2: 34.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "badge_svg__paint2_linear_21011_131738",
    x1: 6.798,
    y1: 5.776,
    x2: 32.958,
    y2: 33.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05224C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2D62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "badge_svg__paint3_linear_21011_131738",
    x1: 26.455,
    y1: 0.585,
    x2: 4.877,
    y2: 63.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#942B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ED7759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19881"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "badge_svg__clip0_21011_131738"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.118 .51)",
    d: "M0 0h40.456v38.208H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "badge_svg__filter0_d_21011_131738",
    x: 1.644,
    y: 2.187,
    width: 39.059,
    height: 37.622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.263,
    dy: 1.263
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21011_131738"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21011_131738",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/badge.f18848ea.svg";
export { SvgBadge as ReactComponent };